import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function PartyPickDialog() {
  const { showPartyPick, setShowPartyPick } = useAuth();
  const navigate = useNavigate();
  const pick = (as) => { setShowPartyPick(false); navigate(`/file-complaint?as=${as}`); };

  return (
    <Dialog open={showPartyPick} onOpenChange={setShowPartyPick}>
      <DialogContent className="sm:max-w-md bg-white" data-testid="party-pick-dialog">
        <DialogHeader><DialogTitle className="font-display">Who is filing this complaint?</DialogTitle></DialogHeader>
        <div className="grid gap-3 pt-2">
          <button onClick={() => pick("customer")} data-testid="pick-customer" className="rounded-xl border-2 border-slate-200 hover:border-teal-brand p-4 text-left transition-colors">
            <p className="font-semibold text-slate-900">I am a Customer</p>
            <p className="text-sm text-slate-500">Complaint about a vendor / service provider</p>
          </button>
          <button onClick={() => pick("vendor")} data-testid="pick-vendor" className="rounded-xl border-2 border-slate-200 hover:border-teal-brand p-4 text-left transition-colors">
            <p className="font-semibold text-slate-900">I am a Vendor</p>
            <p className="text-sm text-slate-500">Complaint about a customer</p>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
